<div class="keyboard-wrapper">
  <div class="keyboard-main">
    <!-- Left section (Uyir) -->
    <div class="keyboard-section uyir">
      <div class="keyboard-row" *ngFor="let row of [0, 1, 2]">
        <button class="key" 
                *ngFor="let key of getUyirKeys() | slice:(row*4):(row*4)+4" 
                (click)="onKeyClicked(key)">
          {{ displayUyirKey(key) }}
        </button>
      </div>
    </div>

    <!-- Right section (Mei) -->
    <div class="keyboard-section mei">
      <div class="keyboard-row" *ngFor="let row of meiKeys">
        <button class="key" 
                *ngFor="let key of row" 
                (click)="onKeyClicked(key)">
          {{ key }}
        </button>
      </div>
    </div>
  </div>

  <!-- Bottom row -->
  <div class="keyboard-bottom">
    <button class="key special" (click)="onKeyClicked('ஃ')">ஃ</button>
    <button class="key space" (click)="onKeyClicked('SPACE')">இடைவெளி</button>
    <button class="key delete" (click)="onKeyClicked('DELETE')">அழி ⌫</button>
    <button class="key enter" (click)="onKeyClicked('ENTER')">இடு ⏎</button>
  </div>
</div>
